// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Map{height:100vh;position:fixed;top:0;width:100vw}", ""]);
// Exports
module.exports = exports;
